<ng-container>
  <span *ngIf="getIconPath(serviceIconsValue)">
    <img
      [class]="{ 'img-border': isDatatable, 'img-border-active-route': isActiveRouteMap }"
      [src]="getIconPath(serviceIconsValue)"
      [alt]="getAltText(serviceIconsValue)"
    />
  </span>
</ng-container>
